import { Typography } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const ChartNoDataContainer = styled.div`
  ${({ theme }) => `
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.background.surface};
    margin-top: 15px;
    flex-direction: column;
  `}
`;

export const NoDataWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  `}
`;

export const ErrorStateHeader = styled.span`
  ${({ theme }) => `
    ${Typography.heading[4].bold};
    color: ${theme.onSurface.surface.default.text.strong};
    margin: 20px 0 ${cxTheme.spacing[2]};
  `}
`;

export const ErrorStateSubtext = styled.span`
  ${({ theme }) => `
    ${Typography.paragraph.small.normal};
    color: ${theme.onSurface.surface.default.text.strong};
  `}
`;
